import { basicInitialState } from '../_utils/basicInitialState';
import { TUsersState } from './usersModel';

export const usersInitialState: TUsersState = {
  ...basicInitialState,
  searchText: '',
  users: []
};
